import React from 'react'
import "./pharmacy.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function Pharmacy() {

   return (
      <>
         <div className="container">
            <CustomTitle title="الصيدلية" />

            <h2 className='main-header mt-5 pt-5'>Pharmacy Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
